import { colors } from '@mui/material';
import { createTheme } from '@mui/material/styles';
const { grey } = colors;

const Colors = {
  primary: '#4ca9ee',
  secondary: '#1fc4ad',
  success: '#00937e',
  info: '#007abb',
  error: '#f06292',
  danger: '#FF5722',
  warning: '#FC8A49',
  dark: '#1a4c6e',
  light: '#67f8df',
  muted: '#FF83CC',
  border: '#DDDFE1',
  inverse: '#2F3D4A',
  shaft: '#333',
  dove_gray: '#d5d5d5',
  body_bg: '#f3f6f9',
  grey_300: grey[300],
  grey_500: grey[500],
  ///////////////
  // Solid Color
  ///////////////
  white: '#fff',
  black: '#000',
  open: '#ff991f',
  collected: '#36b37e',
  flagged: '#ff5630',
  incomplete: '#ff991f',
  completed: '#36b37e',
  cancelled: '#ff5630',
  retrieved: '#c3f7c8',
  lost: '#ffd9d9',
  tagonly: '#fcfcca',
};

const theme = createTheme({
  palette: {
    primary: {
      main: Colors.primary,
    },
    secondary: {
      main: Colors.secondary,
    },
    success: {
      main: Colors.success,
    },
    error: {
      main: Colors.error,
    },
    dark: {
      main: Colors.dark,
    },
    white: {
      main: Colors.white,
    },
    black: {
      main: Colors.black,
    },
    light: {
      main: Colors.light,
    },
    dove_gray: {
      main: Colors.dove_gray,
    },
    grey_300: {
      main: Colors.grey_300,
    },
    grey_500: {
      main: Colors.grey_500,
    },
    body_bg: {
      main: Colors.body_bg,
    },
    open: {
      main: Colors.open,
      contrastText: Colors.white,
    },
    collected: {
      main: Colors.collected,
      contrastText: Colors.white,
    },
    flagged: {
      main: Colors.flagged,
      contrastText: Colors.white,
    },
    incomplete: {
      main: Colors.incomplete,
      contrastText: Colors.white,
    },
    completed: {
      main: Colors.completed,
      contrastText: Colors.white,
    },
    cancelled: {
      main: Colors.cancelled,
      contrastText: Colors.white,
    },
    retrieved: {
      main: Colors.retrieved,
      contrastText: Colors.black,
    },
    lost: {
      main: Colors.lost,
      contrastText: Colors.black,
    },
    tagonly: {
      main: Colors.tagonly,
      contrastText: Colors.black,
    },
  },
  typography: {
    fontFamily: ["'Poppins'", 'sans-serif'].join(','),
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          color: Colors.white,
          backgroundColor: Colors.dark,
          '&:hover': {
            backgroundColor: Colors.info,
          },
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          backgroundColor: Colors.primary,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          borderBottom: '5px solid',
          borderBottomColor: Colors.secondary,
          backgroundColor: Colors.white,
          boxShadow: 'none',
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          backgroundColor: Colors.dark,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        root: {
          backgroundColor: Colors.secondary,
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          backgroundColor: Colors.white,
          color: Colors.dark,
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          backgroundColor: Colors.white,
          color: Colors.dark,
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        toolbarContainer: {
          '> button': {
            margin: 2,
          },
        },
      },
    },
  },
});

export default theme;
